import React, { ReactNode, createContext, useContext, useMemo } from "react";
import { client } from "../../client";
import { useShaneClient } from "../../hooks/UseShaneClient";
import { useAppState } from "../../core/appState/UseAppStateZustand"; // Make sure this import is correct

interface ShaneClientContextType {
  shaneClient: typeof client;
}

const ShaneClientContext = createContext<ShaneClientContextType | null>(null);

interface ShaneClientProviderProps {
  children: ReactNode;
}

export const ShaneClientProvider: React.FC<ShaneClientProviderProps> = ({ children }) => {
  const accessToken = useAppState((state) => state.accessToken);

  const { shaneClient } = useShaneClient({ token: accessToken ?? undefined });

  // re-create context value when the client changes (important!)
  const contextValue = useMemo(() => ({ shaneClient }), [shaneClient]);

  return (
    <ShaneClientContext.Provider value={contextValue}>
      {children}
    </ShaneClientContext.Provider>
  );
};

export const useShaneClientContext = (): ShaneClientContextType => {
  const context = useContext(ShaneClientContext);
  if (!context) {
    throw new Error("useShaneClientContext must be used within a ShaneClientProvider");
  }
  return context;
};
